<div class="admin-dashboard">
  <div class="header-actions">
    <button class="btn-refresh" (click)="onRefresh()" [disabled]="loading">
      <span class="refresh-icon">🔄</span>
      <span>Refresh</span>
    </button>
    <button class="btn-logout" (click)="onLogout()">
      <span class="logout-icon">🚪</span>
      <span>Logout</span>
    </button>
  </div>
  <div class="page-header">
    <div class="header-content">
      <div class="welcome-section">
        <h1 class="page-title">{{ getGreeting() }}, {{ getAdminName() }}</h1>
        <p class="page-subtitle">Welcome to the Admin Panel</p>
      </div>
      <button class="btn-refresh" (click)="onRefresh()" [disabled]="loading">
        <span class="refresh-icon">🔄</span>
        <span>Refresh</span>
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading dashboard...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <h3>Error Loading Dashboard</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="onRefresh()">Try Again</button>
    </div>
  </div>

  <div *ngIf="!loading && !error" class="main-content">
    <div *ngIf="hasUrgentItems()" class="urgent-alert">
      <div class="alert-icon">⚠️</div>
      <div class="alert-content">
        <h3>Items Requiring Attention</h3>
        <div class="urgent-items">
          <span
            *ngFor="let item of getUrgentItems(); let last = last"
            class="urgent-item"
            (click)="navigateTo(item.route)"
          >
            {{ item.count }} {{ item.title }}
            <span *ngIf="!last"> • </span>
          </span>
        </div>
      </div>
    </div>

    <div class="quick-actions-section">
      <h2 class="section-title">Actions</h2>
      <div class="quick-actions-grid">
        <div
          *ngFor="let action of quickActions"
          class="action-card"
          (click)="navigateTo(action.route)"
        >
          <div class="action-icon">
            {{ action.icon }}
          </div>
          <div class="action-content">
            <h3 class="action-title">{{ action.title }}</h3>
            <p class="action-description">{{ action.description }}</p>
          </div>
          <div class="action-arrow">→</div>
        </div>
      </div>
    </div>
  </div>
</div>
